import { Colors, getString } from '@sigma-frontend-libs/commons'

import { buttonModes, components, sizes } from '@/utils'

import render from './render'
import { eventHandlers } from '../../utils/mixins'

const className = 'tag'

export default {
  name: className,

  mixins: [ eventHandlers ],

  props: {
    label: {
      type: [ String, Number, Boolean ],
      default: undefined
    },

    tooltip: [ String, Number ],
    tooltipOptions: Object,

    loading: Boolean,
    disabled: Boolean,
    monospace: Boolean,
    strikethrough: Boolean,
    cancelable: Boolean,
    fluid: Boolean,

    color: {
      type: String,
      default: undefined,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },
    size: {
      type: String,
      default: sizes.medium,
      validator: value => {
        return Object.values(sizes).includes(value)
      }
    },
    mode: {
      type: String,
      default: buttonModes.flat,
      validator: value => {
        return Object.values(buttonModes).includes(value)
      }
    },
    as: {
      type: String,
      default: undefined,
      validator: value => {
        return !!~[ 'button', 'select', 'select-dense', 'link' ].indexOf(value)
      }
    },

    to: {
      type: Object,
      default: undefined
    },

    cancel: {
      type: Function,
      default: () => {
        return undefined
      }
    }
  },

  computed: {
    $_label() {
      return getString(this.label)
    },
    $_tooltip() {
      return getString(this.tooltip)
    },
    $_size() {
      if ([ 'select', 'select-dense' ].includes(this.as)) {
        return this.as
      }

      return this.size
    },
    hasDefault() {
      return !!(this.$scopedSlots.default || this.$slots.default)
    },
    hasContent() {
      if (this.$_label || this.hasDefault) {
        return true
      }

      return false
    },
    preloaderSize() {
      switch (this.$_size) {
        case sizes.tiny: return 4
        case sizes.small: return 5
        case sizes.large: return 7
        case sizes.huge: return 8
        case 'select-dense': return 5
        case 'select': return 6
        case sizes.medium:
        default: return 6
      }
    },
    preloaderCount() {
      switch (this.$_size) {
        case sizes.tiny:
        case 'select-dense': return 2
        default: return 3
      }
    },
    preloaderColor() {
      if (this.mode === buttonModes.filled) {
        if (this.color === Colors.white) {
          return Colors.black
        }

        return Colors.white
      }

      return this.color || Colors.text
    },
    $_tag() {
      if (this.to) {
        return 'router-link'
      }

      return 'div'
    },

    $_class() {
      return {
        [`${className}`]: true,

        [`${className}--${this.mode}`]: true,
        [`${className}-as--${this.as}`]: !!this.as,

        [`${className}--loading`]: this.loading,
        [`${className}--disabled`]: this.disabled,
        [`${className}--monospace`]: this.monospace,
        [`${className}--strikethrough`]: this.strikethrough,
        [`${className}--cancelable`]: this.cancelable,
        [`${className}--fluid`]: this.fluid,

        [`${className}--${this.color}`]: !!this.color,
        [`${className}--${this.$_size}`]: true
      }
    },

    $_directives() {
      const result = []
      if (this.$_tooltip) {
        result.push({
          name: components.tooltip,
          options: {
            value: this.$_tooltip,
            ...this.tooltipOptions
          }
        })
      }

      return result
    }
  },

  render
}
